<template>
    <div class="conversation">
        <div class="conversation-header">
            <img
                class="ion-float-start back-arrow icon-img-sm"
                v-if="windowWidth < 1200"
                src="@/assets/icon-images/arrow-left.png"
                @click="back"
            />
            <div style="cursor:pointer" v-if="contact" @click="$router.push('/user/' + contact.id)">
                <ion-avatar class="avatar ion-float-end">
                    <img
                        :src="
                            contact.approved_images[0]
                                ? `${constants.assetsUri}/${contact.approved_images[0].path}`
                                : require('../assets/imgupload.png')
                        "
                    />
                </ion-avatar>
                <h1 class="ion-float-end">{{ contact ? contact.name : 'Select a contact' }}</h1>
            </div>
        </div>
        <messages-feed v-if="contact" :sending="sending" :contact="contact" :messages="messages" @openPlansPopup="openPlansPopup" />
        <div v-if="!isMobile && !contact" class="empty-feed"></div>
        <send-media-popup
            ref="mediaPopup"
            :path="mediaPath"
            style="display:none"
            :type="mediaType"
            @send="sendMedia"
            @cancel="clearMediaPopup"
        />
        <plans-popup ref="plansPopup" style="display:none" @cancel="clearPlansPopup" />
        <ion-footer>
            <message-composer v-if="contact" @send="sendMessage" @openMediaPopup="openMediaPopup" />
        </ion-footer>
    </div>
</template>

<script>
import MessagesFeed from '@/components/MessagesFeed'
import MessageComposer from '@/components/MessageComposer'
import AxiosController from '@/controllers/AxiosController'
import { isMobile } from 'mobile-device-detect'
import { constants } from '../constants'
import SendMediaPopup from '@/components/SendMediaPopup'
import PlansPopup from '@/components/PlansPopup'

export default {
    name: 'conversation',
    components: { MessagesFeed, MessageComposer, SendMediaPopup, PlansPopup },
    props: ['contact', 'messages'],
    mounted() {
        this.$store.dispatch('fetchNotificationsCount')
    },
    data() {
        return {
            sending: false,
            isMobile,
            constants,
            mediaPath: '',
            mediaType: '',
            mediaFile: ''
        }
    },
    methods: {
        sendMessage: function(message) {
            this.sending = true
            AxiosController.post('/conversation/send', {
                contact_id: this.contact.id,
                title: message.title,
                message: message.text,
                type: 'txt'
            }).then(res => {
                this.sending = false
                this.$emit('new', res.data)
            })
        },
        openMediaPopup(media) {
            this.$refs.mediaPopup.$el.style.display = 'block'
            this.mediaType = media.type
            if (media.type === 'pic' || this.mediaType == 'vid') {
                this.mediaFile = media
                this.mediaPath = media.url
            }
        },
        clearMediaPopup: function() {
            this.$refs.mediaPopup.$el.style.display = 'none'
            this.mediaType = null
            this.mediaPath = null
        },
        openPlansPopup() {
            this.$refs.plansPopup.$el.style.display = 'block'
        },
        clearPlansPopup: function() {
            this.$refs.plansPopup.$el.style.display = 'none'
        },
        sendMedia(message) {
            this.$refs.mediaPopup.$el.style.display = 'none'
            switch (message.type) {
                case 'pic':
                    this.sendPicture(this.mediaFile, message.title)
                    break
                case 'aud':
                    this.sendAudio(message)
                    break
                case 'vid':
                    this.sendVideo(this.mediaFile, message.title)
                    break
                default:
                    break
            }
        },
        sendPicture: function(picture, title) {
            this.sending = true
            const fd = new FormData()
            fd.append('uploaded-file', picture.file)
            fd.append('title', title)
            fd.append('type', 'pic')
            fd.append('contact_id', this.contact.id)
            AxiosController.post('/conversation/send-media', fd).then(res => {
                this.sending = false
                this.$emit('new', res.data)
            })
        },
        sendAudio: function(audio) {
            this.sending = true
            const fd = new FormData()
            fd.append('uploaded-file', audio.file)
            fd.append('title', audio.title)
            fd.append('type', 'aud')
            fd.append('contact_id', this.contact.id)
            AxiosController.post('/conversation/send-media', fd).then(res => {
                this.sending = false
                this.$emit('new', res.data)
            })
        },
        sendVideo: function(video, title) {
            this.sending = true
            const fd = new FormData()
            fd.append('uploaded-file', video.file)
            fd.append('title', title)
            fd.append('type', 'vid')
            fd.append('contact_id', this.contact.id)
            AxiosController.post('/conversation/send-media', fd).then(res => {
                this.sending = false
                this.$emit('new', res.data)
            })
        },
        back: function() {
            this.$emit('back')
        },
        showOptions: function() {
            // dropdown that gives the option to block user
        },
        markAsRead: function(id) {
            this.$store.dispatch('setMessagesAsRead', { contactId: id }).catch(err => console.log(err))
        }
    },
    watch: {
        messages(messages, oldMessages) {
            if (messages.length && messages[messages.length - 1].from == this.contact.id) {
                this.markAsRead(this.contact.id)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
#app[dir='rtl'] .conversation .back-arrow {
    transform: rotate(180deg);
}
.conversation {
    flex: 5;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .conversation-header {
        background-color: #d3d9d9;
        padding: 0 10px;
        position: relative;
        .avatar {
            flex: 1;
            display: flex;
            max-width: 48px;
            max-height: 48px;

            img {
                padding: 5px;
                width: 48px;
                height: 48px;
            }
        }
    }

    h1 {
        font-size: 15px;
        padding: 14px 6px;
        margin: 0;
        border-bottom: 1px dashed lightgray;
        color: #2c3e50;
        font-weight: 600;
    }

    .icon-img-sm {
        position: relative;
        top: 8px;
    }
}

@media (min-width: 768px) {
    h1 {
        font-size: 22px !important;
    }
}

@media (min-width: 1200px) {
    .empty-feed {
        background: #f0f0f0;
        min-height: 600px;
        max-height: 600px;
        background: linear-gradient(rgba(0, 44, 70, 0.5), rgba(0, 44, 70, 0.5)), url('~@/assets/chat-bg.jpg');
        background-position: 50% 20%;
        background-size: cover;
        flex: 1;
    }
}
</style>
